<template>
	<div class="w-dvw max-w-2xl mx-auto h-dvh min-h-dvh max-h-dvh flex flex-col scrollbar-hide text-dark-100 touch-pan-y">
		<div class="w-full flex-1 h-full overflow-y-scroll scrollbar-hide">
			<slot/>
		</div>

		<div class="w-full h-14 bg-dark-900 exclude-poppit">
			<AppMenu/>
		</div>
	</div>
</template>

<script setup>
import AppMenu from "@/Shared/AppMenu.vue";
</script>
